import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Preloader, Oval } from "react-preloader-icon";

import { setClient } from "../../redux/client";

import api from "../../libs/api";

import Dashboard from "./Dashboard";
import EmptyPage from "../../pages/EmptyPage/EmptyPage";

export function DashboardWrapper({ assistants, client, fetchedAssistants, history }) {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    async function fetchProfile() {
      const { data } = await api.get("/clients/profile");
      setProfile(data.profile || {});
      setClient(data);
    }

    if (client && !profile) {
      fetchProfile();
    }
  }, [client, profile]);

  if (!fetchedAssistants || !client || !profile) {
    return (
      <div className="d-flex flex-row justify-content-center pt-3">
        <Preloader use={Oval} size={60} strokeWidth={6} strokeColor="#262626" duration={2000} />
      </div>
    );
  }

  if (assistants.length === 0) {
    return <EmptyPage />;
  }

  return <Dashboard assistants={assistants} client={client} profile={profile} history={history} />;
}

export default withRouter(DashboardWrapper);
